
/*
  UXS — EMAIL GATE V1
  DAY2K / UNIDOS X EL SONIDO

  Pantalla opcional después de guardar
  una señal y antes de VOICE001 V13.

  No modifica audio, transcripción,
  visualizador ni moderación.

  IMPORTANTE:
  El registro real requiere desplegar
  uxs-subscribe-email en Supabase.
*/

(function () {
  "use strict";

  const SUPABASE_URL =
    "https://owwcdrqwfevwbkubrlff.supabase.co";

  const SUPABASE_KEY =
    "sb_publishable_xn5hzUtHdOZNJZ0eRZLr_g_3SmeqUS4";

  const FUNCTION_NAME = "uxs-subscribe-email";

  function init() {
    const root =
      document.getElementById("uxs-experience");

    const recording =
      document.getElementById("uxs-recording");

    if (!root || !recording) return;
    if (root.dataset.emailGateReady) return;

    root.dataset.emailGateReady = "v1";

    const style = document.createElement("style");

    style.id = "uxs-email-gate-styles";

    style.textContent = `
      #uxs-email-gate {
        display: none;
        width: min(90vw, 430px);
        margin: 0 auto;
        box-sizing: border-box;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 22px;
        text-align: center;
        color: #fff;
        font-family: monospace;
      }

      #uxs-experience.uxs-email-stage
      #uxs-email-gate {
        display: flex !important;
        animation: uxs-email-appear .7s ease both;
      }

      #uxs-experience.uxs-email-stage
      #uxs-share-panel,
      #uxs-experience.uxs-email-stage
      #uxs-first-question-subtitle,
      #uxs-experience.uxs-email-stage
      #uxs-audio-interface,
      #uxs-experience.uxs-email-stage
      #uxs-transcription-panel {
        display: none !important;
      }

      #uxs-experience.uxs-email-stage
      #uxs-main {
        display: flex !important;
        flex-direction: column;
        align-items: center !important;
        justify-content: center !important;
        width: 100%;
        min-height: 100svh;
        box-sizing: border-box;
        padding: 25px 16px !important;
      }

      #uxs-experience.uxs-email-stage
      #uxs-recording {
        display: flex !important;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: min(90vw,600px);
        margin: 0 auto !important;
      }

      #uxs-email-title {
        max-width: 420px;
        margin: 0;
        color: #fff;
        font: 400 clamp(19px,4.8vw,28px)/1.55 monospace;
        letter-spacing: 1.5px;
        text-wrap: balance;
      }

      #uxs-email-description {
        max-width: 345px;
        margin: 0;
        color: rgba(255,255,255,.63);
        font: 11px/1.9 monospace;
        letter-spacing: .7px;
      }

      #uxs-email-form {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 12px;
        width: min(100%,330px);
      }

      #uxs-email-input {
        box-sizing: border-box;
        width: 100%;
        min-height: 52px;
        padding: 14px 16px;
        border: 1px solid rgba(255,255,255,.5);
        border-radius: 0;
        outline: none;
        background: transparent;
        color: white;
        font: 13px monospace;
        text-align: center;
      }

      #uxs-email-input::placeholder {
        color: rgba(255,255,255,.4);
      }

      #uxs-email-input:focus {
        border-color: #fff;
      }

      #uxs-email-submit {
        width: 100%;
        min-height: 48px;
        padding: 12px;
        border: 1px solid rgba(255,255,255,.75);
        border-radius: 999px;
        background: transparent;
        color: #fff;
        font: 11px monospace;
        letter-spacing: 1.2px;
        cursor: pointer;
      }

      #uxs-email-submit:hover {
        background: rgba(255,255,255,.08);
      }

      #uxs-email-submit:disabled {
        opacity: .4;
        cursor: wait;
      }

      #uxs-email-skip {
        padding: 12px;
        border: 0;
        background: transparent;
        color: rgba(255,255,255,.62);
        font: 10px monospace;
        letter-spacing: 1px;
        cursor: pointer;
      }

      #uxs-email-skip:hover {
        color: white;
      }

      #uxs-email-privacy {
        max-width: 350px;
        color: rgba(255,255,255,.43);
        font: 9px/1.9 monospace;
        letter-spacing: .4px;
      }

      #uxs-email-feedback {
        min-height: 16px;
        max-width: 350px;
        color: rgba(255,255,255,.7);
        font: 10px/1.9 monospace;
        overflow-wrap: anywhere;
      }

      @keyframes uxs-email-appear {
        from {
          opacity: 0;
          transform: translateY(14px);
        }
        to {
          opacity: 1;
          transform: translateY(0);
        }
      }

      @media (prefers-reduced-motion: reduce) {
        #uxs-email-gate {
          animation: none !important;
        }
      }
    `;

    document.head.appendChild(style);

    const panel = document.createElement("section");

    panel.id = "uxs-email-gate";

    panel.innerHTML = `
      <h2 id="uxs-email-title">
        ¿Y SI ALGUIEN TE RESPONDE?
      </h2>

      <p id="uxs-email-description">
        PODEMOS AVISARTE SI ALGUIEN
        TIENE ALGO MÁS QUE DECIRTE.
      </p>

      <form id="uxs-email-form">
        <input
          id="uxs-email-input"
          type="email"
          inputmode="email"
          autocomplete="email"
          placeholder="TU CORREO ELECTRÓNICO"
          aria-label="Tu correo electrónico"
          maxlength="254"
          required
        >

        <button
          id="uxs-email-submit"
          type="submit"
        >
          QUIERO SABERLO
        </button>
      </form>

      <p
        id="uxs-email-feedback"
        role="status"
        aria-live="polite"
      ></p>

      <button
        id="uxs-email-skip"
        type="button"
      >
        CONTINUAR SIN CORREO
      </button>

      <p id="uxs-email-privacy">
        SI ALGUIEN TE RESPONDE Y NO DEJAS
        UN CORREO, NO PODREMOS AVISARTE.

        TU CORREO SOLO SE UTILIZARÁ PARA
        VERIFICAR TU DIRECCIÓN Y ENVIARTE
        AVISOS SOBRE ESTA SEÑAL.
      </p>
    `;

    recording.appendChild(panel);

    const form =
      panel.querySelector("#uxs-email-form");

    const input =
      panel.querySelector("#uxs-email-input");

    const submit =
      panel.querySelector("#uxs-email-submit");

    const skip =
      panel.querySelector("#uxs-email-skip");

    const feedback =
      panel.querySelector("#uxs-email-feedback");

    let signalId = null;
    let continueExperience = null;
    let busy = false;
    let client = null;

    function getClient() {
      if (!window.supabase?.createClient) {
        throw new Error("SUPABASE_NOT_LOADED");
      }

      if (!client) {
        client = window.supabase.createClient(
          SUPABASE_URL,
          SUPABASE_KEY,
          {
            auth: {
              persistSession: true,
              autoRefreshToken: true,
              detectSessionInUrl: false
            }
          }
        );
      }

      return client;
    }

    function finish() {
      if (busy) return;

      const next = continueExperience;

      continueExperience = null;
      signalId = null;

      root.classList.remove("uxs-email-stage");

      feedback.textContent = "";
      input.value = "";

      if (typeof next === "function") {
        next();
      }
    }

    window.UXSEmailGate = {
      show(options = {}) {
        if (continueExperience) {
          return;
        }

        const id = String(options.signalId || "");
        const next = options.continue;

        if (
          !id ||
          typeof next !== "function"
        ) {
          if (typeof next === "function") {
            next();
          }
          return;
        }

        signalId = id;
        continueExperience = next;

        busy = false;
        submit.disabled = false;
        skip.disabled = false;

        feedback.textContent = "";

        root.classList.add("uxs-email-stage");

        input.value = "";
      }
    };

    skip.addEventListener("click", finish);

    form.addEventListener("submit", async event => {
      event.preventDefault();

      if (busy || !signalId) return;

      const email =
        input.value.trim().toLowerCase();

      if (
        !email ||
        !input.checkValidity()
      ) {
        feedback.textContent =
          "INTRODUCE UN CORREO VÁLIDO.";
        return;
      }

      busy = true;
      submit.disabled = true;
      skip.disabled = true;

      feedback.textContent =
        "PREPARANDO LA VERIFICACIÓN...";

      try {
        const supa = getClient();

        const { data: sessionData, error: sessionError } =
          await supa.auth.getSession();

        if (
          sessionError ||
          !sessionData.session?.access_token
        ) {
          throw new Error("SESSION_REQUIRED");
        }

        const { data, error } =
          await supa.functions.invoke(
            FUNCTION_NAME,
            {
              body: {
                signal_id: signalId,
                email,
                consent: true
              }
            }
          );

        if (error || !data?.success) {
          throw new Error("SUBSCRIPTION_UNAVAILABLE");
        }

        /*
          El backend debe iniciar una
          verificación real por email.

          success NO significa que el email
          ya esté verificado.
        */

        feedback.textContent =
          "REVISA TU CORREO PARA CONFIRMARLO.";

        root.dispatchEvent(
          new CustomEvent(
            "uxs:email-verification-requested",
            {
              bubbles: true,
              detail: { signalId }
            }
          )
        );

        busy = false;
        finish();

      } catch (error) {
        console.warn(
          "UXS email registration:",
          error
        );

        feedback.textContent =
          "NO PUDIMOS ACTIVAR EL AVISO. " +
          "PUEDES INTENTARLO O CONTINUAR SIN CORREO.";

        busy = false;
        submit.disabled = false;
        skip.disabled = false;
      }
    });

    console.log("UXS Email Gate V1 Ready");
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      init
    );
  } else {
    init();
  }
})();
